import { OnInit } from '@angular/core';
var ELEMENT_DATA = [
    { position: 1, addServTitle: 'Notorization', addServDesc: 'Document Translation' },
    { position: 2, addServTitle: ' Apostile', addServDesc: 'Attestation/Apostile of Documents and Implementation of the  Apostile' },
];
var ReportsComponent = /** @class */ (function () {
    function ReportsComponent() {
        this.displayedColumns = ['position', 'addServTitle', 'addServDesc'];
        this.dataSource = ELEMENT_DATA;
    }
    ReportsComponent.prototype.ngOnInit = function () {
    };
    return ReportsComponent;
}());
export { ReportsComponent };
